import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sensorIcon'
})
export class SensorIconPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
